/* import __COLOCATED_TEMPLATE__ from './calls-table.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnly from '@ember/component/template-only';

interface Args {
  label: string;
  data?: any[];
  columns: any[];
  totalPrice: number;
}

interface Signature {
  Args: Args;
}

const CallsTable = templateOnly<Signature>();

export default CallsTable;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::Usage::Phone::CallsTable': typeof CallsTable;
    'billing/usage/phone/calls-table': typeof CallsTable;
  }
}
